import Vue from 'vue'
import Vuex from 'vuex'

import layout from "./layout"
import auth from "./auth"
import register from "@/store/register"
import products from "@/store/products";
import user from "@/store/user";
import menu from "@/store/menu";
import workspace from "@/store/workspace";
import workspaceList from "@/store/workspaceList";
import usersList from "./usersList";
import notifications from "@/store/notifications";
import organizationList from "@/store/organizationList";
import organizationExecutor from "@/store/organizationExecutor";
import organization from "@/store/organization";
import dialog from "@/store/dialog";
import contragents from "@/store/contragents";
import uploadDebtors from "@/store/uploadDebtors";
import subscription from "@/store/subscription";
import userSubscription from "@/store/userSubscription";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    register,
    products,
    usersList,
    layout,
    user,
    menu,
    workspace,
    workspaceList,
    notifications,
    organizationList,
    organizationExecutor,
    organization,
    dialog,
    contragents,
    uploadDebtors,
    subscription,
    userSubscription
  }
});
